import type { QuestionnaireStatus } from "../../api/domain.ts";
import type { Dictionary } from "../../i18n/dictionary.ts";

/** The reader-facing wording of a questionnaire's derived status. */
export const statusLabel = (dictionary: Dictionary, status: QuestionnaireStatus): string => {
  if (status === "evaluated") return dictionary.questionnaires.statusEvaluated;
  if (status === "answered") return dictionary.questionnaires.statusAnswered;
  if (status === "received") return dictionary.questionnaires.statusReceived;
  return dictionary.questionnaires.statusPending;
};
